import type { CaslPermission } from ':helpers/casl/casl.type';

import { CaslAction, CaslSubject } from ':helpers/casl/casl.enum';
import { UserPermission } from ':helpers/casl/permissions/permission.enum';

export type UserPermissionArgs = { organizations: { _id: string }[]; organizationIds: string[] };

export const userCaslPermissions = (permission: UserPermission, user: UserPermissionArgs): CaslPermission => {
    const caslPermissionsByUserPermission: Record<UserPermission, CaslPermission> = {
        [UserPermission.DELETE_ORGANIZATION_USER]: [CaslAction.DELETE, CaslSubject.USER, { organizations: { $in: user.organizationIds } }],
        [UserPermission.MANAGE_ORGANIZATION_USER_CASL_ROLE]: [
            CaslAction.MANAGE,
            CaslSubject.USER,
            ['caslRole'],
            { organizations: { $in: user.organizationIds } },
        ],
        [UserPermission.CREATE_ORGANIZATION_USER]: [CaslAction.CREATE, CaslSubject.USER, { organizations: { $in: user.organizationIds } }],

        [UserPermission.MANAGE_ORGANIZATION_USER_RESTAURANT]: [
            CaslAction.MANAGE,
            CaslSubject.USER_RESTAURANT,
            { 'restaurant.organization': { $in: user.organizationIds } },
        ],

        [UserPermission.CREATE_ORGANIZATION_RESTAURANT]: [
            CaslAction.CREATE,
            CaslSubject.RESTAURANT,
            { organizationId: { $in: user.organizationIds } },
        ],

        [UserPermission.MANAGE_ORGANIZATION_CREDENTIALS]: [
            CaslAction.MANAGE,
            CaslSubject.CREDENTIAL,
            { organization: { $in: user.organizationIds } },
        ],
    };
    return caslPermissionsByUserPermission[permission];
};
